import { useQuery } from '@tanstack/react-query';

import { getEBTChargeAmount } from 'api/jalapeno';

import useAccountQuery from './useAccountQuery';

export const QUERY_KEY = 'ebt-charge-amount';

const useEBTChargeAmountQuery = () => {
    const { data: account } = useAccountQuery();
    const chargeID = account?.nextOrder?.chargeID;

    const query = useQuery({
        queryKey: [QUERY_KEY, chargeID],
        queryFn: async () => {
            const response = await getEBTChargeAmount(chargeID);
            return response?.data;
        },
        enabled: !!chargeID,
    });

    return query;
};

export default useEBTChargeAmountQuery;
